import { render, staticRenderFns } from "./dailyChatOrder.vue?vue&type=template&id=11cddf27&scoped=true&"
import script from "./dailyChatOrder.vue?vue&type=script&lang=js&"
export * from "./dailyChatOrder.vue?vue&type=script&lang=js&"
import style0 from "./dailyChatOrder.vue?vue&type=style&index=0&id=11cddf27&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cddf27",
  null
  
)

export default component.exports